<div class="container-fluid" style="margin-top:70px;">
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-sm-12 col-xs-12 xl-12">
      <div class="custom-card">
        <div class="card-body">
          <h5 class="section-header">REGISTRATION HISTORY</h5>
          <div class="custom-card">
            <mat-tab-group (selectedTabChange)="currentTab($event)">
              <mat-tab label="{{tab}}" *ngFor="let tab of tabs">
                <div id="toBePrinted">
                  <table class="table">
                    <tr>
                      <th>Course</th>
                      <th>Title</th>
                      <th>Unit</th>
                    </tr>
                    <tr *ngFor="let r of reg">
                      <td style="font-family: roboto-bold; color: #4b4b4b">{{r.title | uppercase}}</td>
                      <td>{{r.s_desc | uppercase}}</td>
                      <td>{{r.unit}}</td>
                    </tr>
                    <tr>
                      <td style="font-family: roboto-bold; font-weight: bold" colspan="2">Total Units</td>
                      <td><strong>{{totalRegUnits}}</strong></td>
                    </tr>
                  </table>
                </div>

              </mat-tab>
            </mat-tab-group>
          </div>

        </div>
      </div>
      <button color="primary" type="button" matTooltip="Print" class="floating-btn"
        (click)="print()"><mat-icon>print</mat-icon>
      </button>
    </div>
  </div>
</div>